import { makeStyles, type Theme } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) => ({
	root: {
		display: 'flex',
		height: '100vh',
		overflow: 'hidden',
		width: '100%',
	},
	content: {
		flex: '1 1 auto',
		height: '100%',
		overflow: 'auto',
		padding: '84px 8px 10px 8px',
		[theme.breakpoints.up('lg')]: {
			// paddingLeft: 230,
			padding: '84px 20px 20px 20px',
		},
		backgroundColor: '#f4f6f8',
	},
}));
